module.exports = __webpack_public_path__ + "static/media/ls6-white.e18829f9.svg";